<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Часовой пояс"
    no-data-text="Часовой пояс не найден"
    :request="request"
    :validate="{ included: false }"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { CoreTimezonesApi } from '@/api/resources'

import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteTimezone',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new CoreTimezonesApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
